







































import Vue from 'vue'
import MonthList from '../molecules/MonthList.vue'
import MonthTitle from '../molecules/MonthTitle.vue'
import SubjectButton from '../molecules/SubjectButton.vue'
import NoContentsMessage from '../molecules/NoContentsMessage.vue'
import BaseText from '../atoms/BaseText.vue'
import { ManabiContent } from '@/types/ManabiContent'

export type Subject = {
  name: string
  furigana: string
  anchor: string
  color: string
  subject_id: number
}

export default Vue.extend({
  components: {
    MonthList,
    MonthTitle,
    SubjectButton,
    NoContentsMessage,
    BaseText
  },
  props: {
    hideTitle: {
      type: Boolean,
      default: false
    },
    contents: {
      type: Object,
      required: true
    },
    untilMonth: {
      type: String,
      required: false
    },
    isSubjectButton: {
      type: Boolean,
      default: false
    },
    subjects: {
      type: Array as () => Subject[],
      default: null
    },
    showAll: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    year(this: { $store: { state: { year: number } } }) {
      return this.$store.state.year
    },
    month(this: { $store: { state: { month: number } } }) {
      if (!this.$store.state.month) return ''
      return this.$store.state.month
    },
    filteredContents(
      this: {
        $store: {
          state: {
            year: number | null,
            month: number | null,
            contents: Record<
            string, {contents: ManabiContent[]}
            >
          }
        }
      }
    ): ManabiContent[] {
      if (!this.$store.state.year || !this.$store.state.month) return []

      const key =
        this.$store.state.year.toString() +
        ('0' + this.$store.state.month).slice(-2)

      const data = this.$store.state.contents[key]

      return data ? data.contents : []
    }
  }
});
